module.exports = __webpack_public_path__ + "static/img/8.617c3fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/mobile/sky101/8.png
// module id = s8yY
// module chunks = 1